import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ErisFormComponent } from 'eris-forms';

@Component({
  selector: 'app-eris-form-modal',
  templateUrl: './eris-form-modal.component.html',
  styleUrls: ['./eris-form-modal.component.css']
})
export class ErisFormModalComponent implements OnInit, OnDestroy {

  @Input() title : string;
  @Input() fields: any;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() submitForm: EventEmitter<any> = new EventEmitter<any>();
  
  @ViewChild(ErisFormComponent) erisFormComponent!: ErisFormComponent;
  
  constructor() { }

  ngOnInit(): void {
  }

  onCloseModal() {
    this.closeModal.emit();
  }
  
  onSubmit(data) {
    this.submitForm.emit(data);
  }

  ngOnDestroy() {
    this.erisFormComponent.form.reset();
  }
}
